import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import PromotionsList from './PromotionsList';
import { useParams } from 'react-router-dom';
import { getExperience } from 'api/node/experiences';
import { useAsync } from 'react-async';
import ExperienceHeader from '../Form/Partials/ExperienceHeader';
import PromotionCreate from './PromotionCreate';
import PromotionDetails from './PromotionDetails';
import PromotionDuplicate from './PromotionDuplicate';
import ExperienceLayout from '../Form/Partials/ExperienceLayout';

const PromotionsContainer = ({ isReadOnly = false }) => {
  const { experienceId } = useParams();
  const { data: experienceData, isLoading } = useAsync({
    promiseFn: getExperience,
    experienceId: experienceId,
  });

  return (
    <ExperienceLayout>
      <ExperienceHeader values={experienceData?.data} />
      <Routes>
        <Route
          path=""
          element={!isLoading && <PromotionsList isReadOnly={isReadOnly} />}
        />
        <Route
          path="new"
          element={
            isReadOnly ? (
              <Navigate relative="path" to=".." replace />
            ) : (
              <PromotionCreate experience={experienceData?.data} />
            )
          }
        />
        <Route
          path=":promotionId"
          element={
            <PromotionDetails
              experience={experienceData?.data}
              isReadOnly={isReadOnly}
            />
          }
        />
        <Route
          path="duplicate/:promotionId"
          element={
            isReadOnly ? (
              <Navigate relative="path" to=".." replace />
            ) : (
              <PromotionDuplicate experience={experienceData?.data} />
            )
          }
        />
      </Routes>
    </ExperienceLayout>
  );
};

export default PromotionsContainer;
